// extracted by mini-css-extract-plugin
export var brand = "_7x-8";
export var compact = "_7x-5";
export var extraSmall = "_7x-6";
export var icon = "_7x-0";
export var large = "_7x-3";
export var light = "_7x-1";
export var medium = "_7x-4";
export var outline = "_7x-a";
export var primaryDark = "_7x-9";
export var primaryLight = "_7x-7";
export var primaryModern = "_7x-b";
export var success = "_7x-2";